import { styled } from 'styled-components';
import { Image } from '@/shared/ui/image/Image';
import { Box } from '@/shared/ui/box/Box';
import { WRAPPER } from '@/shared/styles/themes';
import { brandIsPh } from '@/shared/config/brand-by-target.mjs';

export const BonusWrapper = styled.div`
  ${WRAPPER};
  display: flex;
  flex-direction: column;
  gap: 30px;

  @media (max-width: 768px) {
    margin: 0;
    gap: 12px;
  }
`;
export const BonusFilters = styled.div`
  display: flex;
  height: 44px;
  //padding: 0 394px;
  align-items: center;
  gap: 12px;
  align-self: stretch;

  @media (max-width: 1024px) {
    overflow: auto;
  }
  @media (max-width: 768px) {
    overflow: auto;
    :first-child {
      margin-left: 18px;
    }
    :last-child {
      margin-right: 18px;
    }
  }
`;
export const FilterButton = styled.div<{ $isActive?: boolean }>`
  display: flex;
  height: 40px;
  padding: 0 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 9px;
  flex: 1 0 0;
  cursor: pointer;

  border-radius: 8px;
  background: ${({ $isActive }) => ($isActive ? '#4B444C' : '#27262b')};

  white-space: nowrap;
`;
export const BonusList = styled.div`
  display: grid;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 80px;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 1131px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 12px;
    padding: 0 16px;
  }
`;

export const BonusItem = styled.div<{ $isActive?: boolean }>`
  overflow: hidden;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 8px;

  ${({ $isActive }) =>
    $isActive &&
    `
    border: 2px solid #FF9F0A;
  `}

  @media (max-width: 768px) {
    border-radius: 0;
  }
`;

export const BonusItemNew = styled.div<{
  $isCarousel?: boolean;
  $bg?: string;
  $isEnable?: boolean;
  $tint?: string;
  $isActive?: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  aspect-ratio: 364 / 220;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  border-radius: 8px;

  @media (max-width: 768px) {
    aspect-ratio: 343 / 150;

    ${({ $isCarousel }) =>
      !$isCarousel &&
      `
        min-height: 184px;
      `}
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    //border-radius: 8px;
    background: url(${(props) => props.$bg}) center/cover no-repeat;

    transition: transform 0.3s ease;
    transform-origin: 75% 50%;

    ${({ $isEnable }) =>
      !$isEnable &&
      `
          filter: saturate(0);          
          z-index: 1;
        `}
  }

  &:hover::before {
    transform: scale(1.1);
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;

    background: ${({ $isEnable, $tint }) => {
      if (!$isEnable) return 'rgba(25, 38, 75, 0.5)';
      return brandIsPh
        ? 'transparent'
        : `linear-gradient(270deg, rgba(153, 89, 0, 0.00) 30.77%, ${$tint} 100%)`;
    }};

    ${({ $isActive }) =>
      $isActive &&
      `
      border-radius: 8px;
      border: 2px solid #FF9F0A;

      @media (max-width: 768px) {
        border-radius: 12px;
      }
    `}

    z-index: 2;
  }

  > * {
    position: relative;
    z-index: 3;
  }

  @media (max-width: 768px) {
    border-radius: 12px;
  }
`;

export const ProviderImage = styled(Image)`
  margin: 0 auto;
`;
export const BonusImage = styled.div<{
  $imageUrl?: string;
  $dialogMode?: boolean;
}>`
  background-image:
    linear-gradient(180deg, rgba(19, 19, 21, 0) 0%, #131315 100%),
    url(${(props) => props.$imageUrl});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 150px;
  position: relative;
  z-index: 5;
  aspect-ratio: 136 / 75;

  @media (max-width: 768px) {
    height: 133px;
    background-size: cover;
  }
`;

export const BonusContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 16px;
  gap: 16px;
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 10px 12px;
    gap: 8px;
  }
`;

export const EventName = styled.div`
  letter-spacing: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: stretch;
  text-overflow: ellipsis;
  overflow: hidden;
`;
export const BonusName = styled.div<{ $isCarousel?: boolean }>`
  color: #fff;
  letter-spacing: 0;
  text-shadow: 0 1.138px 1.138px rgba(11, 21, 46, 0.5);

  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 28.8px */
  white-space: pre-line;

  @media (max-width: 768px) {
    ${({ $isCarousel }) =>
      !$isCarousel &&
      `
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        text-overflow: ellipsis;
        overflow: hidden;
      `}
  }
`;

export const BonusActionsWrapper = styled(Box)<{ $isCarousel?: boolean }>`
  ${({ $isCarousel }) => !$isCarousel && 'flex-shrink: 0;'}
`;
export const BonusDialogContent = styled.div<{ $modBonus?: boolean }>`
  position: relative;
  width: 364px;
  border: 1px solid var(--2-c-344-a-40, #131315);
  background: #131315;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    overflow: auto;
    border-radius: 0px;
    background: #040404;
  }

  ${({ $modBonus }) =>
    $modBonus &&
    `
      width: 420px;
      height: 90vh;

        @media (max-width: 768px) {
    width: 100%;
    height: 100%;
  }
  `}
`;

export const DetailItems = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 5px;
`;

export const DetailItem = styled.div<{ $fill?: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  border-radius: 5px;
  background: rgba(61, 60, 65, 0.5);
  padding: 8px 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  ${({ $fill }) =>
    $fill &&
    `
      flex-basis: 100%;
  `}
`;

export const BurnWarningWrapper = styled.div`
  background-color: #321d26;
  position: relative;
  padding: 20px;
  display: flex;
  justify-content: center;
  width: 80px;
  margin: 0 auto;
  border-radius: 50%;
`;

export const GamesWrapper = styled.div<{ $centered?: boolean }>`
  display: grid;
  grid-template-columns: repeat(2, 155px);
  gap: 12px;
  // margin-top: 8px;
  // padding-bottom: 16px;
  position:relative;
  z-index: 5;

  ${({ $centered }) =>
    $centered &&
    `
      grid-template-columns: repeat(1, 169px);
      justify-content:center;

  `}

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 115px);
    ${({ $centered }) =>
      $centered &&
      `
      grid-template-columns: repeat(1, 115px);
      justify-content:center;

  `}
`;

export const TimerBlock = styled.div`
  display: flex;
  height: 40px;
  padding: 0 clamp(5px, 50%, 24px);
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;

  border-radius: 50px;
  background: #202b6c;
  white-space: nowrap;
  overflow: hidden;
`;

export const BonusDetails = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px;
  gap: 24px;
  height: 100%;
  overflow-y: scroll;
  margin-bottom: 74px;

  .customBtn {
    ${TimerBlock} {
      display: block;
      height: auto;
      padding: 0;
      justify-content: initial;
      justify-items: initial;
      align-content: initial;
      align-items: initial;
      border-radius: 0;
      background: transparent;
      white-space: normal;
      overflow: visible;
      text-align: center;
      width: 100%;
      margin: -10px;
    }
  }
`;

export const NavigationBackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;

export const BackButtonIcon = styled.div`
  width: 16px;
  height: 16px;
  background-image: url(/images/icons/arrow-right-white.svg);
  background-repeat: no-repeat;
  background-position: center center;
  opacity: 0.7;
`;

export const HeaderActionsBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-top: 30px;

  @media (max-width: 768px) {
    gap: 12px;
    margin-top: 12px;
  }
`;

export const BackButtonBox = styled.div`
  width: fit-content;
  padding: 0;

  @media (max-width: 768px) {
    padding: 0 18px;
  }
`;
